import * as types from '../_actions/actionTypes'
import _ from 'lodash'

export function employeeLeave(
    state = { currentDate: new Date(), loading: true },
    action
) {
    switch (action.type) {
        case types.UPDATE_CURRENT_DATE:
            return _.merge({}, state, {
                currentDate: action.payload.currentDate,
            })
        case types.FETCH_EMPLOYEE_LEAVE:
            return {
                ...state,
                ...action.payload,
                displayLeaves: action.payload.leaves,
                loadingEvents: false,
            }
        case types.FETCH_EMPLOYEE_LEAVE_WEEKLY:
            return {
                ...state,
                ...action.payload,
                displayWeeklyLeaves: action.payload.leaves,
                loadingEvents: false,
            }
        case types.FETCH_EMPLOYEE_LEAVE_FAILURE:
            return state
        case types.UPDATE_DISPLAY_LEAVE:
            return Object.assign({}, state, {
                displayLeaves: action.cond.displayEvents,
            })
        default:
            return state
    }
}
